<div class="cart-proceed-to-checkout">
  <cx-progress-button [class]="'btn btn-block'" [routerLink]="{ cxRoute: 'category',params: { code: '0101' } } | cxUrl" tabindex="-1">
    {{ "cart.btn.continue" | cxTranslate }}
  </cx-progress-button>
  <cx-progress-button (click)="onContinueBtnClick()" [class]="'btn btn-block'" tabindex="-1"
    [disabled]="invalidFormData || invalidQuantity">
    {{ "cart.btn.proceed" | cxTranslate }}
  </cx-progress-button>
</div>